import {
	AfterViewInit,
	Directive,
	ElementRef,
	Input,
	OnInit,
} from '@angular/core';

type BtnType = 'action' | 'outline' | 'icon' | 'link' | 'text';

const ButtonTypes: Map<BtnType, string> = new Map([
	['action', 'btn-action'],
	['outline', 'btn-outline'],
	['icon', 'btn-icon'],
	['link', 'btn-link'],
	['text', 'btn-text'],
]);

@Directive({
	selector: '[cmvBtn]',
})
export class BtnDirective implements OnInit {
	@Input() cmvBtn: BtnType;
	constructor(private el: ElementRef) {
		this.addButtonClass(this.cmvBtn);
	}
	ngOnInit(): void {
		this.addButtonClass(this.cmvBtn);
	}

	private addButtonClass(btnType: BtnType) {
		this.el.nativeElement.classList.add(ButtonTypes.get(btnType));
	}
}
